import React from "react";
import ReactDOM from "react-dom/client";

import "./index.css";
import App from "App";
import { HelmetProvider } from "react-helmet-async";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
      <HelmetProvider>
    <App />
    </HelmetProvider>
  </React.StrictMode>
);
